import React from 'react';
import {IMaskInput} from 'react-imask';
import styles from './input.module.css';

class InputAmount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    }
  }

  handleValue(value, mask) {
    this.setState({value: value});
    if(mask) {
      const e = mask.el.input;
      e.classList.remove("invalid-input");
      e.nextSibling.innerText = '';
    }
  }

  handleValidate(e) {
    var val = e.target.value;
    var length = e.target.getAttribute("length");
    var required = e.target.getAttribute("data-required");
    var dataError = e.target.getAttribute("data-error");
    if (length) {
      if (parseInt(length, 10) !== val.length) {
        e.target.className += " invalid-input";
        if (dataError) {
          var errorMessage = "<span class='error-message'>" + dataError + "</span>";
        }
        else {
          // eslint-disable-next-line
          var errorMessage = "<span class='error-message'>Длина поля " + length + " символов</span>";
        }
        e.target.nextSibling.innerHTML = errorMessage;
      }
      else {
        e.target.classList.remove("invalid-input");
        e.target.nextSibling.innerText = '';
      }
    }
    else {
      if ((required === "true") && val.length < 1) {
        e.target.className += " invalid-input";
        const errorMessage = "<span class='error-message'>Обязательное поле</span>";
        e.target.nextSibling.innerHTML = errorMessage;
      }
      else {
        if (Number(val) === 0) {
          var el = e.target;
          setTimeout(function(){
            el.className += " invalid-input";
            el.nextSibling.innerHTML = "<span class='error-message'>Сумма должна быть больше 0</span>";
          }, 10);
        }
        else {
          e.target.classList.remove("invalid-input");
          e.target.nextSibling.innerText = '';
        }
      }
    }
  }

  render() {
    return (
      <div>
        <div className={styles.label}>{this.props.label}</div>
        <div className={styles.amount}>
          <IMaskInput
              scale={2}
              radix='.'
              mapToRadix={[',']}
              padFractionalZeros={true}
              mask={this.props.mask} unmask={true}
              onBlur={this.handleValidate}
              onAccept={(value, mask) => this.handleValue(value, mask)}
              className={styles.input} defaultValue={this.props.defaultValue}
              name={this.props.name} placeholder={this.props.placeholder}
              maxLength={this.props.maxlength}
              length={this.props.length} data-error={this.props.error}
              type="text" data-required={this.props.required} disabled={this.props.disabled}
              value={this.state.value} onChange={this.props.onChange}/>
          <div className={styles.underinput}>{this.props.underinput}</div>
          <div className={styles.amountCurrency}>₽</div>
        </div>
      </div>
    );
  }

}

export default InputAmount;